module.exports = __webpack_public_path__ + "ea624bddab381685e944d95f879da7ee.png";